module.exports = __webpack_public_path__ + "img/Promoters_16.31a20637.png";